import React from "react"
import { AnimatePresence, motion } from "framer-motion"
import { FaXmark } from "react-icons/fa6"

const SlideOver = ({ show, title, subtitle, onClose, actions, children, disableClose = false, noPad = false }) => {
    const close = () => {
        if (!disableClose && typeof onClose === "function") onClose()
    }

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    className="fixed inset-0 z-[80] flex justify-end bg-slate-950/45 backdrop-blur-sm"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={close}
                >
                    <motion.aside
                        className="flex h-full w-full max-w-[1180px] flex-col overflow-hidden border-l border-borderColor bg-pColor shadow-2xl"
                        initial={{ x: "100%" }}
                        animate={{ x: 0 }}
                        exit={{ x: "100%" }}
                        transition={{ type: "spring", damping: 30, stiffness: 260 }}
                        onClick={(event) => event.stopPropagation()}
                    >
                        <div className="flex items-start justify-between gap-4 border-b border-borderColor bg-white px-6 py-5">
                            <div>
                                <p className="text-xs font-bold uppercase tracking-[0.24em] text-primeColor">Quick Create</p>
                                <h2 className="mt-1 text-2xl font-semibold text-tColor">{title}</h2>
                                {subtitle && <p className="mt-1 max-w-2xl text-sm leading-6 text-tpColor">{subtitle}</p>}
                            </div>
                            <div className="flex shrink-0 items-center gap-3">
                                {actions}
                                <button
                                    type="button"
                                    className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-borderColor bg-white text-tColor shadow-sm transition ${
                                        disableClose
                                            ? "cursor-not-allowed opacity-50"
                                            : "hover:border-primeColor hover:text-primeColor"
                                    }`}
                                    onClick={close}
                                    disabled={disableClose}
                                    aria-label="Close panel"
                                >
                                    <FaXmark />
                                </button>
                            </div>
                        </div>
                        <div className={`flex-1 overflow-y-auto ${noPad ? "p-0" : "px-5 py-5 md:px-8"}`}>
                            {children}
                        </div>
                    </motion.aside>
                </motion.div>
            )}
        </AnimatePresence>
    )
}

export default SlideOver
